module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "学员批量结课"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "BatchCompletedCoursesForm",
    staticClass: "form",
    attrs: {
      "model": _vm.batchCompletedCoursesParam,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学员ID",
      "prop": "uIds"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": "id以 ; 拼接"
    },
    model: {
      value: (_vm.batchCompletedCoursesParam.uIds),
      callback: function($$v) {
        _vm.$set(_vm.batchCompletedCoursesParam, "uIds", $$v)
      },
      expression: "batchCompletedCoursesParam.uIds"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "结课类型",
      "prop": "completedType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true
    },
    model: {
      value: (_vm.batchCompletedCoursesParam.completedType),
      callback: function($$v) {
        _vm.$set(_vm.batchCompletedCoursesParam, "completedType", _vm._n($$v))
      },
      expression: "batchCompletedCoursesParam.completedType"
    }
  }, _vm._l((_vm.completedTypeList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingBatchCompletedCourses
    },
    on: {
      "click": _vm.batchCompletedCourses
    }
  }, [_vm._v("结课\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-081f0177","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/BatchCompletedCoursesModal.vue
// module id = 1609
// module chunks = 8